import { Link } from "react-router-dom";
import HeroSlider from "../components/HeroSlider";
import TrendingProducts from "../components/TrendingProducts";
import NewArrivals from "../components/NewArrivals";
import BestSellers from "../components/BestSellers";
import BlogSection from "../components/BlogSection";
import FeaturedProducts from "../components/FeaturedProducts";
import BrandsSection from "../components/BrandsSection";
import MostViewedProducts from "../components/MostViewedProducts";
import TrendingListing from "../components/TrendingListing";
import ImageWithSkeleton from "../components/ImageWithSkeleton";

export default function HomePage() {
  return (
    <main className="bg-white min-h-screen font-sans antialiased text-gray-700 selection:bg-[#43a047] selection:text-white">
      {/* Hero Slider */}
      <HeroSlider />

      <div className="py-6 bg-white">
        <div className="max-w-7xl mx-auto px-4 ">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-4">
            <div className="md:col-span-4">
              <Link
                to="/products"
                className="block overflow-hidden relative banner-thumb-effect"
              >
                <ImageWithSkeleton
                  src={`${process.env.PUBLIC_URL}/img/product/WfUdchhGvqcuStrOASZ7YzoJDebiNaNZcqLxd0fw.webp`}
                  alt="banner"
                  containerClassName="w-full h-[220px] md:h-[450px]"
                  className="w-full h-[220px] md:h-[450px] object-cover"
                />
              </Link>
            </div>

            <div className="md:col-span-5">
              <Link
                to="/products"
                className="block overflow-hidden relative banner-thumb-effect"
              >
                <ImageWithSkeleton
                  src={`${process.env.PUBLIC_URL}/img/product/sC5oSHRRplnOotM78ncZYspjl91DgeWIdjdNf2tH.webp`}
                  alt="banner"
                  containerClassName="w-full h-[220px] md:h-[450px]"
                  className="w-full h-[220px] md:h-[450px] object-cover"
                />
              </Link>
            </div>

            {/* Banners 3 & 4 */}
            <div className="md:col-span-3 flex flex-col gap-4">
              <Link
                to="/products"
                className="block overflow-hidden relative flex-1 banner-thumb-effect"
              >
                <ImageWithSkeleton
                  src={`${process.env.PUBLIC_URL}/img/product/cIG7sPy3rZhSjlKHlq1qVRDuN7I4YO4kTPJ8s2nr.webp`}
                  alt="banner"
                  containerClassName="w-full h-[160px] md:h-[250px]"
                  className="w-full h-[160px] md:h-[250px] object-cover"
                />
              </Link>
              <Link
                to="/products"
                className="block overflow-hidden relative flex-1 banner-thumb-effect"
              >
                <ImageWithSkeleton
                  src={`${process.env.PUBLIC_URL}/img/product/collection-of-organic-legumes-and-seeds-in-baskets-photo (1).jpg`}
                  alt="banner"
                  containerClassName="w-full h-[160px] md:h-[205px]"
                  className="w-full h-[160px] md:h-[205px] object-cover"
                />
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Mostview Products Section Container Styling */}
      <section className="py-10 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-10">
            <p className="text-sm italic text-[#43a047] font-serif tracking-wide mb-1">
              Recently added our store
            </p>
            <h2 className="text-2xl md:text-3xl font-medium text-[#112244] tracking-wide relative inline-block">
              All Products
            </h2>
          </div>

          {/* TrendingProducts handles structural cards internally, but global scope fits here */}
          <TrendingProducts />

          {/* Grid Layout Replica for Visual Consistency to the main image row */}
        
        </div>
      </section>

      {/* New Arrivals Internal Hook */}
      <NewArrivals />

      {/* Full Width Sale Banner - Formatted with Background Image & Styling accurately matching Image */}
      <div
        className="bg-cover bg-center py-16 text-left relative my-10 min-h-[220px] flex items-center"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/img/slider/slider10.png)`,
        }}
      >
        <div className="absolute inset-0 bg-white/20 backdrop-blur-[1px]" />
        <div className="relative max-w-7xl mx-auto px-8 w-full">
          <h2 className="text-2xl md:text-3xl font-light text-[#112244] tracking-tight uppercase mb-6 leading-tight">
            <span className="font-bold">all Fresh  products</span>
          </h2>
          <Link
            to="/products"
            className="inline-block btn-readmore px-6 py-2 text-xs font-bold uppercase tracking-wider rounded-full   transition-colors"
          >
            Discover Now
          </Link>
        </div>
      </div>

      {/* Best Sellers Title Alignment */}
      <section className="py-10 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-12">
            <p className="text-sm italic text-[#43a047] font-serif tracking-wide mb-1">
              Recently added our store
            </p>
            <h2 className="text-2xl md:text-3xl font-medium text-[#112244] tracking-wide">
              Best Sellers
            </h2>
          </div>

          {/* BestSellers internal dynamic component execution */}
          <BestSellers />
        </div>
      </section>

      {/* Most Viewed Products Section */}
      <MostViewedProducts />

      {/* Trending Products Listing Section */}
      <TrendingListing />

      {/* Blog Posts Block Formatting */}
      <section className="py-10 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <BlogSection />
        </div>
      </section>

      {/* Wide Horizontal Mid Banner with Fresh Veggie Slice Graphic Replica */}
      {/* <div className="py-6 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div
            className="w-full h-44 bg-cover bg-center rounded-sm relative flex items-center p-8 border border-gray-100 overflow-hidden"
            style={{ backgroundImage: "url(/img/product/fruit-basket-holds-abundance-healthy-variety-generated-by-ai_188544-13371.avif" }}
          >
            <div className="relative z-10 text-left">
         
              <h3 className="text-xl font-normal text-gray-800 uppercase tracking-tight">
                Sale <span className="font-bold">50% Off</span> All Vegetable
                Products     
              </h3>
            </div>
            
            <div className="absolute right-0 top-0 bottom-0 w-1/3 bg-gradient-to-l from-white/30 to-transparent pointer-events-none" />
          </div>
        </div>
      </div> */}

      {/* Featured Products Component Section Wrapping Style */}
      {/* <section className="py-12 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <FeaturedProducts />
        </div>
      </section> */}

      {/* Brands Section Boundary Border Styling Box */}
      <div className="py-8 bg-white border-t border-gray-50">
        <div className="max-w-7xl mx-auto px-4">
          <div className="border border-gray-200 rounded-sm py-6 bg-white px-4">
            <BrandsSection />
          </div>
        </div>
      </div>
    </main>
  );
}